import { replaceString } from 'src/api/demo';
import { getUserIdentity } from 'src/api/identity';
import { useTargetingContext } from 'src/contexts/TargetingContext';
import ApiService from 'src/views/pages/Dsp/Common/ApiService';
import { DEFAULT_TABLE_SETTINGS } from 'src/views/pages/targetting/master-search/components/save-action';

const { useCallback } = require('react');

const useDefaultProfile = () => {

  const { targetingDispatch } = useTargetingContext();

  const authToken = JSON.parse(localStorage.getItem('User')) || {};

  const removeDefaultProfile = useCallback(async (selectedProfileId) => {

    const identity = getUserIdentity(`${process.env.REACT_APP_HTTP_URL}`, {}, selectedProfileId);

    const headers = {
      'Authorization': `Bearer ${authToken?.token}`,
      'X-USER-IDENTITY': identity,
    }

    const currentCacheTargetingSettings = JSON.parse(sessionStorage.getItem('cacheTargetingSettings') || '{}') || {}
        
    const updatedCacheTargetingSettings = {
        ...currentCacheTargetingSettings,
        [selectedProfileId?.profileId]: DEFAULT_TABLE_SETTINGS || {}
    }

    sessionStorage.setItem('cacheTargetingSettings', JSON.stringify(updatedCacheTargetingSettings));

    targetingDispatch({
      type: 'UPDATE_TARGETING_SETTINGS_DEFAULT',
      payload: updatedCacheTargetingSettings
    });


    await ApiService(`/user-default/delete-default-records`, 'POST', {
      report: 'amazon',
    }, headers);
    
  }, []);

  return {
    removeDefaultProfile
  };
};

export default useDefaultProfile;
